<template>
    <div class="default-select" ref="parentEl" :class="[{'error' : errors.length}, {'default-select--selected' : value}]">
        <div class="default-select__body">
            <slot></slot>
            <label class="default-select__label">{{ label }}</label>
            <div class="default-select__dropdown" id="slim-dropdown"></div>
        </div>
        <div class="default-select__error" v-if="errors.length">
            <span>{{ errors[0].$message }}</span>
        </div>
    </div>
</template>

<script>

export default {
    name: "InputSelect",
    props: {
        required: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number, Array, Object],
            default: null
        },
        errors: {
            type: Array,
            default: () => []
        }
    },
}
</script>

<style scoped>

</style>